module.exports = __webpack_public_path__ + "img/menu10.6ed26ec1.png";